import URLS from '@d-shared/urls/urls';

import BooksSearchService from './books-search-service';

export default new BooksSearchService(URLS.api.books);
